import {Component, inject, input, OnInit} from '@angular/core';
import {HsFormsService} from '@core/services/hs-forms.service';

@Component({
  selector: 'app-storyblok-hubspot-embed-form',
  templateUrl: './storyblok-hubspot-embed-form.component.html',
  styleUrls: ['./storyblok-hubspot-embed-form.component.scss'],
  imports: []
})
export class StoryblokHubspotEmbedFormComponent implements OnInit {
  readonly portalId = input.required<string>();
  readonly formId = input.required<string>();
  readonly region = input.required<string>();
  private hsFormsService = inject(HsFormsService);

  ngOnInit(): void {
    this.hsFormsService.addEmbedForm(this.portalId())
  }

}
